import { render, staticRenderFns } from "./AnularVenta.vue?vue&type=template&id=2d7546d4"
import script from "./AnularVenta.vue?vue&type=script&lang=js"
export * from "./AnularVenta.vue?vue&type=script&lang=js"
import style0 from "./AnularVenta.vue?vue&type=style&index=0&id=2d7546d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports